// extracted by mini-css-extract-plugin
module.exports = {"card":"Empty_card__2q6bi","text":"Empty_text__3UuCH"};